const TYPE = 'SET_ACTIVE_GROUP';

const action = (id) => (dispatch) => dispatch({ type: TYPE, payload: id });

export default { action, TYPE };
